import { render, staticRenderFns } from "./OrderParty.vue?vue&type=template&id=5beb6632&scoped=true"
import script from "./OrderParty.vue?vue&type=script&lang=ts"
export * from "./OrderParty.vue?vue&type=script&lang=ts"
import style0 from "./OrderParty.vue?vue&type=style&index=0&id=5beb6632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beb6632",
  null
  
)

export default component.exports